import React, { useEffect, useState, useCallback } from "react";
import styles from "./RulesBaseComponent.module.css";
import Spinner from "../../../common/Spinner/Spinner";
import DataSourcePill from "../../../common/DataSourcePill/DataSourcePill";
import ComingSoonComponent from "../../../common/ComingSoonComponent/ComingSoonComponent";
import { useAuth } from "../../../../context/AuthContext";
import { RulesAPI } from "../../../../utils/firebase";

const RulesBaseComponent = () => {
  const { user } = useAuth();
  const email = (user?.email || "").trim();

  const [state, setState] = useState({
    loading: true,
    error: null,
    items: [],
    fromCache: null,
  });

  const load = useCallback(async ({ bypassCache = false } = {}) => {
    if (!email) {
      setState({ loading: false, error: new Error("No user email."), items: [], fromCache: null });
      return;
    }
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const { value, fromCache } = await RulesAPI.fetchUserRulesOnceWithMeta(
        email,
        bypassCache ? { noCache: true } : {}
      );
      setState({ loading: false, error: null, items: value, fromCache });
    } catch (e) {
      setState({ loading: false, error: e, items: [], fromCache: null });
    }
  }, [email]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="container-fluid">
      <div className="pp-page">
        <div className="pp-page-header d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <h1 className="pp-page-title">Rules</h1>
            <DataSourcePill
              fromCache={state.fromCache}
              loading={state.loading}
              onRefresh={() => load({ bypassCache: true })}
            />
          </div>
          <div className="pp-page-actions"></div>
        </div>

        {state.loading && (
          <div className="py-5 d-flex justify-content-center">
            <Spinner label="Loading rules..." />
          </div>
        )}

        {!state.loading && state.error && (
          <div className="alert alert-danger" role="alert">
            <strong>Failed to load rules.</strong>
            <div className="small mt-1">{state.error.message}</div>
          </div>
        )}

        {!state.loading && !state.error && (
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              {state.items.length === 0 ? (
                // <div className="text-muted">No rules yet.</div>
                <ComingSoonComponent/>
              ) : (
                <ul className="mb-0">
                  {state.items.map((r) => (
                    <li key={r.id || `${r.name}-${r.createdAt}`}>{r.name || r.id}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RulesBaseComponent;
